// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"a77ee967","513":"a449bf36","703":"154f094d"}[chunkId] + ".chunk.js";
};